export default "<div *ngIf=\"displaySpinner\" [class]=\"showSpinner+(centered ? ' centered' : '')\"></div>\n"